// 과정의 서류제출 설정(isSupDocument)이 이 신청 구분(일반/지원)을 대상으로 하는지.
// Y = 지원만(기존 값), G = 일반만, A = 일반·지원 모두, N = 사용 안 함. 값이 없으면 기존과 같이 지원만.
export const isSupDocumentTarget = (isSupDocument, sugangSupType) => {
  switch (isSupDocument) {
    case "N":
      return false;
    case "A":
      return sugangSupType === "지원" || sugangSupType === "일반";
    case "G":
      return sugangSupType === "일반";
    default:
      return sugangSupType === "지원";
  }
};
